import React from 'react';

interface Props {
  html?: string;
  className?: string;
}

const HTMLText: React.FC<Props> = ({ html, className }) =>
  html ? <div className={className} dangerouslySetInnerHTML={{ __html: html }} /> : null;

export default HTMLText;
